import type { Lieferwunsch } from '@/types/detail';

/**
 * Die Wortlaute zum Lieferwunsch (A56, #135).
 *
 * EINE QUELLE, NICHT DREI: Der Wortlaut steht im Erfassungs-Formular,
 * in der Bestellung und im Verlauf. Stünde er dreimal, liefe er
 * auseinander — und im Verlauf stünde dann etwas anderes als auf dem
 * Schirm (Fallstrick 15). Dieselben Sätze stehen noch einmal in
 * api/lib/kundenwunsch.php, weil das Protokoll sie beim SCHREIBEN
 * festhält; das ist eine bewusste Spiegelung, keine zweite Wahrheit.
 */
export const LIEFERWUNSCH_LABEL: Record<Lieferwunsch, string> = {
  komplett: 'Erst wenn alles da ist',
  sofort: 'Sobald etwas da ist'
};

/** Was gilt, wenn niemand etwas sagt — der häufigere Fall. */
export const LIEFERWUNSCH_VORGABE: Lieferwunsch = 'komplett';

/** Ein kurzer Zusatz für die Zeile, an der entschieden wird. */
export const LIEFERWUNSCH_KURZ: Record<Lieferwunsch, string> = {
  komplett: 'komplett',
  sofort: 'Teillieferung erwünscht'
};

/**
 * Ist ein Wert von der Vorgabe abweichend?
 *
 * Gebraucht dort, wo ein zugeklappter Bereich zeigen muss, dass in ihm
 * etwas steht — ein Bereich, der das verschweigt, ist eine Falle.
 */
export function lieferwunschAbweichend(w: Lieferwunsch): boolean {
  return w !== LIEFERWUNSCH_VORGABE;
}
